import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10 bg-[color:var(--prmu-bg)]">
      <div className="compliance-strip py-3 text-center px-6">
        For research use only — not for human or veterinary consumption
      </div>
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="font-display text-5xl leading-none select-none">
            <span className="text-white">PRM</span>
            <span className="accent-slash">U</span>
          </div>
          <div className="mt-2 overline text-zinc-500">Your Health. <span className="accent-slash">Primed.</span></div>
          <p className="mt-6 text-sm text-zinc-500 max-w-sm leading-relaxed">
            Precision-made research peptides and reference compounds — the standard we'd want on our own shelf. Fast, discreet, and easy to reorder.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="chip">Batch-Traceable</span>
            <span className="chip">Fast Shipping</span>
            <span className="chip">Human Support</span>
          </div>
        </div>
        <div>
          <div className="overline mb-4">Catalog</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-blue-400 transition-colors">Shop all</Link></li>
            <li><Link to="/shop?category=peptides" className="hover:text-blue-400 transition-colors">Peptides</Link></li>
            <li><Link to="/shop?category=reference-compounds" className="hover:text-blue-400 transition-colors">Reference compounds</Link></li>
            <li><Link to="/shop?category=solvents-consumables" className="hover:text-blue-400 transition-colors">Consumables</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-blue-400 transition-colors">About PRMU</Link></li>
            <li><Link to="/partners" className="hover:text-blue-400 transition-colors">Partner program</Link></li>
            <li><Link to="/shop" className="hover:text-blue-400 transition-colors">Shop all</Link></li>
            <li><Link to="/account" className="hover:text-blue-400 transition-colors">My account</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 lg:px-10 py-6 text-xs font-mono text-zinc-600 flex flex-col md:flex-row justify-between gap-2 max-w-[1400px] mx-auto tracking-widest">
        <div>© {new Date().getFullYear()} PRMU — ALL RIGHTS RESERVED</div>
        <div className="uppercase">Research use only · Not for human or veterinary use</div>
      </div>
    </footer>
  );
}
